import React, { forwardRef } from "react";
import styled from "styled-components";

const StyledTextarea = styled.textarea`
    width: ${(props) => props.width || "100%"};
    height: ${(props) => props.height || "150px"};
    margin: ${(props) => props.$margin || "0"}; /* $ 접두사 사용 */
    padding: 10px;
    border: 2px solid #E0E0E0;
    border-radius: 5px;
    font-size: 16px;
    resize: none;

    &:focus {
        outline: none;
        border-color: #2980b9;
        box-shadow: 0 0 5px rgba(41, 128, 185, 0.5);
    }

    &:read-only {
        background-color: #f9f9f9;
        border-color: gray;
        color: #333;
        cursor: default;
    }
    &:disabled {
        background-color: #F5F5F5;
        border-color: #bbb;
        color: gray;
        cursor: not-allowed;
    }
`;

const TextArea = forwardRef(({ width, height, maxLength = 200, value, onChange, readOnly = false, disabled = false, placeholder = "", margin = '0' }, ref) => {
    const handleChange = (e) => {
        onChange(e.target.value.slice(0, maxLength));
    };

    return (
        <div>
            <StyledTextarea
                ref={ref}
                width={width}
                height={height}
                maxLength={maxLength}
                readOnly={readOnly}
                disabled={disabled}
                value={value === null || value === undefined ? '' : value}
                onChange={handleChange}
                placeholder={placeholder}
                $margin={margin} /* $ 접두사 붙여서 전달 */
            />
        </div>
    );
});

export default TextArea;